import React from 'react';
import SideNav from 'components/layout-components/SideNav';
import MobileNav from 'components/layout-components/MobileNav';
import HeaderNav from 'components/layout-components/HeaderNav';
import Footer from 'components/layout-components/Footer';
import AppViews from 'views/app-views';
import { Layout } from 'antd';

import { useTheme } from 'context/ThemeProvider/ThemeProvider';

const { Content } = Layout;

export const AppLayout = () => {
  const { isMobile } = useTheme();
  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobile && <SideNav />}
      <Layout>
        <HeaderNav />
        <Content style={{ padding: 24 }}>
          <AppViews />
        </Content>
        <Footer />
      </Layout>
      {isMobile && <MobileNav />}
    </Layout>
  );
};

export default AppLayout;
